import React from 'react';
import { Shield } from 'lucide-react';

interface InsalubriteCat2ConfigProps {
  config: {
    joursTravaillesParMois: number;
  };
  onChange: (config: { joursTravaillesParMois?: number }) => void;
  montantDemiJournee: number;
}

export default function InsalubriteCat2Config({ config, onChange, montantDemiJournee }: InsalubriteCat2ConfigProps) {
  const handleJoursChange = (joursTravaillesParMois: number) => {
    console.log('🛡️ InsalubriteCat2Config - handleJoursChange called');
    console.log('🛡️ InsalubriteCat2Config - new joursTravaillesParMois:', joursTravaillesParMois);
    console.log('🛡️ InsalubriteCat2Config - current config:', config);
    onChange({ joursTravaillesParMois });
  };

  const calculatePrimeAmount = () => {
    const result = montantDemiJournee * 2 * config.joursTravaillesParMois;
    console.log('🛡️ InsalubriteCat2Config - calculatePrimeAmount:', {
      montantDemiJournee,
      joursTravaillesParMois: config.joursTravaillesParMois,
      result
    });
    return result;
  };

  console.log('🛡️ InsalubriteCat2Config - Rendering with config:', config);
  console.log('🛡️ InsalubriteCat2Config - montantDemiJournee:', montantDemiJournee);

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">
          <Shield className="w-4 h-4 inline mr-1" />
          Nombre de jours travaillés par mois
        </label>
        <div className="flex items-center gap-2">
          <input
            type="number"
            value={config.joursTravaillesParMois}
            onChange={(e) => {
              e.stopPropagation();
              console.log('🛡️ InsalubriteCat2Config - input onChange triggered');
              console.log('🛡️ InsalubriteCat2Config - new value:', e.target.value);
              handleJoursChange(Number(e.target.value));
            }}
            onClick={(e) => e.stopPropagation()}
            onFocus={(e) => e.stopPropagation()}
            min="0"
            max="31"
            step="1"
            className="w-20 px-2 py-1 text-sm border border-gray-300 rounded focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
          <span className="text-sm text-gray-600">jours</span>
          <span className="text-sm text-gray-500 ml-2">
            = {(config.joursTravaillesParMois * 2)} taux de base
          </span>
        </div>
        <div className="mt-2 text-xs text-gray-500">
          Nombre de jours d'exposition aux risques d'insalubrité par mois (2 demi-journées par jour)
        </div>
      </div>
    </div>
  );
}